import { useEffect, useRef, useState } from "react";

type AsyncStatusProps = {
  busy: boolean;
  busyMessage: string;
  completeMessage?: string;
};

function AsyncStatus({ busy, busyMessage, completeMessage = "" }: AsyncStatusProps) {
  const previousBusy = useRef(busy);
  const [message, setMessage] = useState(busy ? busyMessage : "");

  useEffect(() => {
    if (busy) {
      setMessage(busyMessage);
    } else if (previousBusy.current) {
      setMessage(completeMessage);
    }

    previousBusy.current = busy;
  }, [busy, busyMessage, completeMessage]);

  return (
    <span className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </span>
  );
}

export default AsyncStatus;
